// Auth0 configuration for Deep Research application
// All values from environment variables with fallbacks for development
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-m5fzc4ep3wiatwmb.us.auth0.com',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'Stlj3zFcamdOHZyqFc8uVwZEvRs6q3TU',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE, // Optional - can be undefined
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin,
  scope: process.env.REACT_APP_AUTH0_SCOPE || 'openid profile email'
};

// Log environment variables for debugging
console.log('Auth0 Config Debug:', {
  domain: process.env.REACT_APP_AUTH0_DOMAIN ? 'SET' : 'NOT SET',
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ? 'SET' : 'NOT SET',
  audience: process.env.REACT_APP_AUTH0_AUDIENCE ? 'SET' : 'NOT SET',
  redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI ? 'SET' : 'NOT SET',
  scope: process.env.REACT_APP_AUTH0_SCOPE ? 'SET' : 'NOT SET'
});

// PRODUCTION DEBUG: Log actual values (remove after debugging)
console.log('🔍 PRODUCTION AUTH0 DEBUG - ACTUAL VALUES:');
console.log('Domain:', process.env.REACT_APP_AUTH0_DOMAIN);
console.log('Client ID:', process.env.REACT_APP_AUTH0_CLIENT_ID);
console.log('Redirect URI env:', process.env.REACT_APP_AUTH0_REDIRECT_URI);
console.log('Window origin:', window.location.origin);
console.log('Final config:', {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  redirectUri: auth0Config.redirectUri
});

// Auth0 provider configuration
export const providerConfig = {
  domain: auth0Config.domain,
  clientId: auth0Config.clientId,
  authorizationParams: {
    redirect_uri: auth0Config.redirectUri,
    ...(auth0Config.audience && { audience: auth0Config.audience }), // Only add if defined
    scope: auth0Config.scope
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage' as const,
  sessionCheckExpiryDays: 7, // Remember user for 7 days
  legacySameSiteCookie: false,
  // Enable silent authentication for better UX
  skipRedirectCallback: false,
  // Automatically try to renew tokens when they expire
  authorizeTimeoutInSeconds: 60,
};